import BaseBehavior from '../../../framework/base/base';
import { initBehaviors, destroyBehaviors } from '../../../shared/utilities/behaviors';
import { hideElement, showElement } from '../../../shared/utilities/show-hide';

export default class LoadMore extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.addEventListeners();
		this.headers = new window.Headers();
		this.headers.append('Accept', 'text/*, text/html, text/html;level=1, */*');
	}

	addEventListeners() {
		if (!this.dom.button) {
			return;
		}
		this.addEventListener(this.dom.button, 'click', e => {
			e.preventDefault();
			e.stopPropagation();
			showElement(this.dom.spinner);
			hideElement(this.dom.button);
			this.loadMore(this.element.dataset.url);
		});
	}

	loadMore(url) {
		if (!url) return;
		const request = new window.Request(url, { headers: this.headers });

		window
			.fetch(request)
			.then(response => response.text())
			.then(html => {
				const domParser = new DOMParser();
				const itemTarget = domParser
					.parseFromString(html, 'text/html')
					.querySelector('[data-item-target]');
				// if item container selector is provided then, new items shall be appended to corresponding dom.
				const container = itemTarget
					? this.element.parentNode.querySelector(itemTarget.dataset.itemTarget)
					: this.element.parentNode;
				// Just add unparsed dom string to container(parsing can remove isolated tags like tr/td)
				container.insertAdjacentHTML('beforeend', html);
				// pick up load more button container
				initBehaviors({ context: container });

				const loadMoreSource = container.querySelector('[data-load-more-source]');
				// check whether load more button is available. No load-more button means no more data to load.
				if (loadMoreSource) {
					const dpContainer = loadMoreSource.closest('.dynamic-pricing__content-section');
					if (dpContainer && loadMoreSource.childElementCount) {
						dpContainer.insertAdjacentElement('afterend', loadMoreSource.firstElementChild);
					} else if (loadMoreSource.childElementCount) {
						this.element.insertAdjacentElement('afterend', loadMoreSource.firstElementChild);
					}
					loadMoreSource.parentNode.removeChild(loadMoreSource);
				}
				if (window.picturefill) {
					window.picturefill({ elements: container.querySelectorAll('picture img') });
				}
				// remove js reference of old load more.
				destroyBehaviors({ context: this.element });
				// remove DOM reference of old load more.
				this.element.parentNode.removeChild(this.element);
				this.publish('loadmore/finished');
			})
			.catch(() => {
				hideElement(this.dom.spinner);
				showElement(this.dom.button);
			});
	}

	removeEventListeners() {
		if (this.dom.button) {
			this.removeEventListener(this.dom.button, 'click');
		}
	}

	cleanup() {
		this.removeEventListeners();
	}
}
